module.exports = __webpack_public_path__ + "img/1Kedi.8f16153a.svg";